import { createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d0a7b9b")

_pushScopeId("data-v-7d0a7b9b")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "bouncing__item" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "bouncing__item" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "bouncing__item" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade-in",
    appear: ""
  }, {
    default: _withId(() => [
      _createVNode("div", {
        class: ["bounce df-cross-center", {pause: _ctx.pause}]
      }, [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3
      ], 2)
    ]),
    _: 1
  }))
})